export default [
  {
    path: 'learning-strategy',
    name: 'learning-strategy',
    component: () => import('../LearningStrategy.vue'),
    meta: {
      title: 'Learning Strategy',
      sort: 4,
      external: true,
      excludeFromRoot: true,
      authenticatable: false,
      icon: 'mdi-book-multiple-variant',
    },
  },
]
